// extracted by mini-css-extract-plugin
module.exports = {"container":"CountRepos_container__UbB9p"};